<template>
  <div class="dashboard-container">
    <a-row :gutter="20" style="margin-bottom: 20px">
      <a-col :span="16">
        <div>
          <p class="top-title">概览</p>
          <a-row :gutter="20">
            <a-col :span="8">
              <OverviewBox
                title="站点总数"
                :number="baseInfoOverview.spiderTotalNum"
                :today="baseInfoOverview.spiderTodayNum"
                :yestoday="baseInfoOverview.spiderYesterdayNum"
              />
            </a-col>
            <a-col :span="8">
              <OverviewBox
                title="采集总数"
                :number="baseInfoOverview.resultTotalNum"
                :today="baseInfoOverview.resultTodayNum"
                :yestoday="baseInfoOverview.resultYesterdayNum"
              />
            </a-col>
            <a-col :span="8">
              <DutyNum
                :today="baseInfoOverview.taskTodayNum"
                :yestoday="baseInfoOverview.taskYesterdayNum"
              />
            </a-col>
          </a-row>
        </div>
      </a-col>
      <a-col :span="8">
        <div>
          <p class="top-title">节点状态</p>
        </div>
        <a-row :gutter="20">
          <a-col :span="12">
            <NodeNumber title="正常节点数" :type="1" :count="serverStat.normalNum" />
          </a-col>
          <a-col :span="12">
            <NodeNumber title="异常节点数" :type="0" :count="serverStat.abNormalNum" />
          </a-col>
        </a-row>
      </a-col>
    </a-row>

    <a-row style="margin-bottom: 20px" :gutter="20">
      <a-col :span="16">
        <CardTemplate size="large" title="实时调度任务">
          <TodayTask :spiderStatDaily="spiderStatDaily" />
        </CardTemplate>
      </a-col>
      <a-col :span="8">
        <CardTemplate size="small" title="站点异常监控">
          <!-- <router-link
            :to="{ name: 'monitor_abnormal', query: { type: 'site' } }"
            class="action-slot"
            slot="action"
            >详情
          </router-link> -->
          <TimeSelector v-model="statSpiderDay" />
          <PieChart
            :data="spiderSpiderError"
            :colors="['#FF95A2', '#81F4DA', '#6DB9FF']"
            jumpName="monitor_abnormal"
            :type="statSpiderDay"
          />
        </CardTemplate>
      </a-col>
    </a-row>

    <div class="row">
      <CardTemplate size="large" title="实时采集流量" style="position:relative">
        <div slot="action" class="data-type-btn">
          <a-radio-group v-model="dataType" @change="onChange">
            <a-radio-button value="hour">
              时
            </a-radio-button>
            <a-radio-button value="day">
              日
            </a-radio-button>
            <a-radio-button value="week">
              周
            </a-radio-button>
            <a-radio-button value="month">
              月
            </a-radio-button>
          </a-radio-group>
        </div>
        <FlowLine size="large" :flowData="flowLines" ></FlowLine>
      </CardTemplate>
    </div>

    <a-row :gutter="20" style="margin-bottom: 20px">
      <a-col :span="16">
        <CardTemplate size="large" title="当日国家占比">
          <WorldMap :data="countrys" />
        </CardTemplate>
      </a-col>
      <a-col :span="8">
        <CardTemplate size="large" title="当日语言占比">
          <Country id="lang" size="large" :data="langs"> </Country>
        </CardTemplate>
      </a-col>
    </a-row>
    <div class="row">
      <CardTemplate size="large" title="当日采集量最多排行">
        <Rank
          size="large"
          :data="crawlRanks"
          :colors="['#6ab0e4', '#d7efff']"
          :classData="spiderClassMap"
        />
      </CardTemplate>
      <CardTemplate size="large" title="当日文件类型">
        <FileType :data="fileTypes"></FileType>
      </CardTemplate>
      <CardTemplate size="large" title="数据采集来源总数">
        <CollectionFlow />
      </CardTemplate>
    </div>
  </div>
</template>

<script>
import CardTemplate from './components/CardTemplate'
import TodayTask from './components/TodayTask'
import TimeSelector from './components/TimeSelector'
import PieChart from './components/PieChat'
import CollectionFlow from './components/CollectionFlow'
import FlowLine from './components/FlowLine.vue'
import Country from './components/Country.vue'
import Rank from './components/Rank.vue'
import FileType from './components/FileType.vue'
import OverviewBox from './components/overviewBox.vue'
import NodeNumber from './components/NodeNumber.vue'
import DutyNum from './components/dutyNum.vue'
import MixLine from './components/MixLine.vue'
import WorldMap from './components/worldMap.vue'

import {
  getBaseInfoSpiderNumApi,
  getBaseInfoSpiderResultNumApi,
  getBaseInfoSpiderTaskNumApi,
  getStatServerApi,
  getStatTaskNumByTodayApi,
  getStatTaskErrorApi,
  getStatSpiderErrorApi,
  getCrawlFlowApi,
  getCrawlCountryApi,
  getCrawlLangApi,
  getCrawlRankApi,
  getCrawlFileTypeTodayApi
} from '../../api/Dashboard/index'

import { querySpiderClassInfoApi } from '../../api/Site/Type'

import { onHttpResponseSilent } from '../../utils/request'

export default {
  components: {
    CardTemplate,
    TodayTask,
    TimeSelector,
    PieChart,
    CollectionFlow,
    FlowLine,
    Country,
    Rank,
    FileType,
    OverviewBox,
    NodeNumber,
    DutyNum,
    MixLine,
    WorldMap
  },
  data() {
    return {
      baseInfoOverview: {
        resultTodayNum: 0,
        resultTotalNum: 0,
        resultYesterdayNum: 0,
        spiderTodayNum: 0,
        spiderTotalNum: 0,
        spiderYesterdayNum: 0,
        taskTodayNum: 0,
        taskTotalNum: 0,
        taskYesterdayNum: 0
      },

      serverStat: {
        abNormalNum: 3,
        normalNum: 0,
        totalNum: 3
      },

      spiderStatDaily: {
        spiderParseFailNum: 0,
        spiderParseNum: 0,
        spiderParseSuccNum: 0,
        spiderRequestFailNum: 0,
        spiderRequestNum: 0,
        spiderRequestSuccNum: 0,
        spiderScheduleDealNum: 0,
        spiderScheduleErrorNum: 0,
        spiderScheduleHandKillNum: 0,
        spiderScheduleNum: 0,
        spiderScheduleQueueNum: 0,
        spiderScheduleRepeatNum: 0,
        spiderScheduleStartFailNum: 0,
        spiderScheduleStartNum: 0,
        spiderScheduleSuccNum: 0,
        spiderScheduleUnKnownNum: 0
      },

      spiderTaskErrorDay: 1,
      spiderTaskError: [],

      statSpiderDay: 0,
      spiderSpiderError: [],
      flowLines: [],
      countrys: [],
      langs: [],
      crawlRanks: [],
      spiderClassMap: {},
      fileTypes: [],
      dataType:'hour'
    }
  },
  created() {
    const dataTypeStorage = localStorage.getItem('dataType')
    if(dataTypeStorage){
      this.dataType=dataTypeStorage
    }else{
      localStorage.setItem('dataType',this.dataType)
    }
    this.getBaseInfoOverview()
    this.getStatServer()
    this.getStatTaskNumByToday()
    this.getStatTaskError()
    this.getStatSpiderError()
    this.queryCrawlFlow()
    this.queryCrawlCountry()
    this.queryCrawlLang()
    this.queryClass()
    this.queryCrawlRank()
    this.queryCrawlFileType()
  },
  watch: {
    spiderTaskErrorDay() {
      this.getStatTaskError()
    },
    statSpiderDay() {
      this.getStatSpiderError()
    }
  },
  methods: {
    getBaseInfoOverview() {
      this.queryBaseInfoSpiderNumApi()
      this.queryBaseInfoSpiderResultNumApi()
      this.queryBaseInfoSpiderTaskNumApi()
    },

    /**
     * 获取总站点数
     */
    async queryBaseInfoSpiderNumApi() {
      let res = await getBaseInfoSpiderNumApi()
      let { extra, code } = res
      if (code == 200) {
        this.baseInfoOverview.spiderTotalNum = extra.totalNum
        this.baseInfoOverview.spiderTodayNum = extra.todayNum
        this.baseInfoOverview.spiderYesterdayNum = extra.yesterdayNum
      }
    },
    /**
     * 获取采集总数
     */
    async queryBaseInfoSpiderResultNumApi() {
      let res = await getBaseInfoSpiderResultNumApi()
      let { extra, code } = res
      if (code == 200) {
        this.baseInfoOverview.resultTotalNum = extra.totalNum
        this.baseInfoOverview.resultTodayNum = extra.todayNum
        this.baseInfoOverview.resultYesterdayNum = extra.yesterdayNum
      }
    },

    /**
     * 获取任务数
     */
    async queryBaseInfoSpiderTaskNumApi() {
      let res = await getBaseInfoSpiderTaskNumApi()
      let { extra, code } = res
      if (code == 200) {
        this.baseInfoOverview.taskTodayNum = extra.todayNum
        this.baseInfoOverview.taskYesterdayNum = extra.yesterdayNum
      }
    },

    /**
     * 获取实时采集流量
     */
    async queryCrawlFlow() {
      let res = await getCrawlFlowApi({type:this.dataType})
      res = res || []
      this.flowLines = []
      res.forEach((flow) => {
        let flowLine = []
        flowLine.push(['hour','day'].includes(this.dataType)?flow.time.substring(11, 16):flow.time.substring(0,11))
        flowLine.push(flow.cnt)
        this.flowLines.push(flowLine)
      })
      this.flowLines.reverse()
    },
    onChange(e){
      this.dataType = e.target.value
      localStorage.setItem('dataType',e.target.value)
      this.queryCrawlFlow()
    },
    /**
     * 获取国家采集数据
     */
    async queryCrawlCountry() {
      let res = await getCrawlCountryApi()
      res = res || {}
      let countryList = []

      for (var country in res) {
        let temp = {}
        temp['value'] = res[country]
        temp['name'] = country
        countryList.push(temp)
      }
      countryList = this.quickSort(countryList)
      this.countrys = this.modalShowListData(countryList)
    },

    /**
     * 获取语言采集数据
     */
    async queryCrawlLang() {
      let res = await getCrawlLangApi()
      res = res || {}
      let langList = []

      for (var lang in res) {
        let temp = {}
        temp['value'] = res[lang]
        temp['name'] = lang
        langList.push(temp)
      }
      langList = this.quickSort(langList)
      this.langs = this.modalShowListData(langList)
    },

    /**
     * 获取采集量排行
     */
    async queryCrawlRank() {
      let res = await getCrawlRankApi({ top: 6 })
      this.crawlRanks = res || []
    },

    /**
     * 获取分类
     */
    async queryClass() {
      let res = await querySpiderClassInfoApi({ pageSize: 1000 })
      let { data } = res
      data.forEach((item) => {
        this.spiderClassMap[item['type']] = true
      })
    },

    /**
     * 获取站点文件下载的类型
     */
    async queryCrawlFileType() {
      let res = await getCrawlFileTypeTodayApi()

      let { extra, code } = res
      if (code == 200) {
        let fileTypeMap = extra['spiderFileTypeDaily']
        for (var key in fileTypeMap) {
          if (key != 'uk') {
            let name = key
            if (key == 'image') {
              name = '图片'
            } else if (key == 'video') {
              name = '视频'
            } else if (key == 'doc') {
              name = '文献'
            }

            let temp = {}
            temp['value'] = fileTypeMap[key]
            temp['name'] = name
            this.fileTypes.push(temp)
          }
        }
        if (fileTypeMap['uk'] != null) {
          this.fileTypes.push({
            value: fileTypeMap['uk'],
            name: '其他'
          })
        }
      }
    },

    getStatServer() {
      getStatServerApi()
        .then(onHttpResponseSilent)
        .then((res) => {
          this.serverStat = res.extra.serverStat
        })
    },

    getStatTaskNumByToday() {
      getStatTaskNumByTodayApi()
        .then(onHttpResponseSilent)
        .then((res) => {
          this.spiderStatDaily = res.extra.spiderStatDaily
        })
    },

    getStatTaskError() {
      getStatTaskErrorApi({ day: this.spiderTaskErrorDay })
        .then(onHttpResponseSilent)
        .then((res) => {
          const spiderError = res.extra.spiderTaskError
          let data = [
            {
              type: '运行时间长',
              value: spiderError.longTimeTotalNum || 0,
              code: 8
            },
            {
              type: '重复',
              value: spiderError.repeatTotalNum || 0,
              code: 6
            },
            {
              type: '启动失败',
              value: spiderError.startFailTotalNum || 0,
              code: 3
            },
            {
              type: '异常退出',
              value: spiderError.errorTotalNum || 0,
              code: -3
            }
          ]
          this.spiderTaskError = data
        })
    },

    getStatSpiderError() {
      getStatSpiderErrorApi({ day: this.statSpiderDay })
        .then(onHttpResponseSilent)
        .then((res) => {
          const spiderSpiderError = res.extra.spiderSpiderError
          let data = [
            {
              type: '解析率＜50% /h',
              value: spiderSpiderError.lowRateTotalNum || 0,
              code: 0
            },
            {
              type: '采集量＞1w条 /h',
              value: spiderSpiderError.largeResultTotalNum || 0,
              code: 1
            },
            {
              type: '24h内采集量为0',
              value: spiderSpiderError.noResultTotalNum || 0,
              code: 2
            }
          ]
          this.spiderSpiderError = data
        })
    },
    /**
     * 快排
     */

    quickSort(list) {
      if (list.length <= 1) {
        return list
      }

      var pivotIndex = Math.floor(list.length / 2)

      var pivot = list.splice(pivotIndex, 1)[0]

      var left = []

      var right = []

      for (var i = 0; i < list.length; i++) {
        if (list[i]['value'] > pivot['value']) {
          left.push(list[i])
        } else {
          right.push(list[i])
        }
      }

      return this.quickSort(left).concat([pivot], this.quickSort(right))
    },
    /**
     * 格式化统计
     */
    modalShowListData(list, length) {
      if (list.length < length) {
        return list
      }
      let newList = []
      let otherNum = 0
      newList = list.splice(0, 5)
      list.forEach((data) => {
        otherNum += data['value'] || 0
      })

      if (otherNum > 0) {
        newList.push({
          name: '其他',
          value: otherNum
        })
      }
      return newList
    }
  }
}
</script>

<style lang="less" scoped>
.dashboard-container {
  width: 100%;
  padding: 15px 30px;

  .top-title {
    font-size: 18px;
    color: #333;
  }

  .count-box {
    background: #fff;
  }

  .row {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
  }

  .first-row-content {
    height: 160px;
    display: flex;

    .node-cell {
      flex: 1 1 0;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .number {
        font-size: 48px;
        font-family: DengXian;
        font-weight: bold;
        letter-spacing: 2px;

        &.normal {
          color: #6bcc6b;
        }

        &.ab-normal {
          color: #ed7878;
        }
      }

      .tip {
        color: #999;
      }
    }
  }

  .action-slot {
    margin-left: auto;
    transform: translateY(3px);
  }
  .data-type-btn{
    position: absolute;
    right:30px;
  }
}
</style>
